import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { SidebarItem } from 'src/constants/sidebarConstants';

import Button from '../../Button/Button';
import classes from '../SidebarLink.module.scss';

export interface SidebarLinkItemProps {
  link: SidebarItem;
  collapsed?: boolean;
  onClick?: () => void;
}

const SidebarLinkItem: FC<SidebarLinkItemProps> = ({
  link,
  onClick,
  collapsed = false,
}) => {
  return (
    <NavLink
      onClick={() => onClick?.()}
      to={link.pathname}
      className={({ isActive }) =>
        classNames(classes.SidebarLink, {
          [classes.SidebarLinkActive]: isActive,
          [classes.HideText]: collapsed,
        })
      }
    >
      <Button
        startIcon={link.icon && <FontAwesomeIcon icon={link.icon} />}
        fullWidth
      >
        {!collapsed ? link.label : null}
      </Button>
    </NavLink>
  );
};

export default SidebarLinkItem;
